import type {
  SilaeMemberSchema,
  SilaeMetaStatusCount
} from '@libs/data-access/entities'
import type {
  PaginatedQueryResponse,
  UseAppQueryOptions
} from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type { FetchSilaeSynchronizedMembersOptions } from '../silae.synchronization.api'
import { fetchSilaeSynchronizedMembers } from '../silae.synchronization.api'
import { silaeSynchronizationCacheKeys } from '../silae.synchronization.cacheKeys'

export const useFetchSilaeSynchronizedMembers = (
  request: FetchSilaeSynchronizedMembersOptions,
  queryOptions?: UseAppQueryOptions<
    PaginatedQueryResponse<
      SilaeMemberSchema,
      'memberships',
      { status_count: SilaeMetaStatusCount }
    >
  >
) => {
  return useQuery({
    ...queryOptions,
    queryKey: silaeSynchronizationCacheKeys.all(request?.queryParams),
    queryFn: () => fetchSilaeSynchronizedMembers(request)
  })
}
